import CloseIcon from "@mui/icons-material/Close";
import { Alert, AlertTitle, IconButton, Stack } from "@mui/material";
import {
  boundSearchableZoom,
  meshDisplayableZoom
} from "common/consts/estates";
import { stickyNoteSearchableZoom } from "common/consts/stickyNotes";
import React from "react";
import styles from "./LimitZoomsCollapse.module.scss";
import { useHooks } from "./hooks";

export const LimitZoomsCollapse = React.memo(
  (props: {
    bound: boolean;
    sold: boolean;
    stickyNote: boolean | undefined;
    pricing: boolean;
    zoom: number;
  }) => {
    const {
      openBound,
      openSold,
      openStickyNote,
      openPricing,
      onCloseBound,
      onCloseSold,
      onCloseStickyNote,
      onClosePricing
    } = useHooks();

    return (
      <Stack className={styles.limitZoomsCollapse} spacing={2}>
        {openBound && props.bound && props.zoom < boundSearchableZoom ? (
          <Alert
            severity="info"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onCloseBound}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle className={styles.alertTitle}>
              Zoom = {boundSearchableZoom} より地図範囲検索は有効になります
            </AlertTitle>
            (現在 Zoom = {props.zoom})
          </Alert>
        ) : null}
        {openSold && props.sold && props.zoom < meshDisplayableZoom ? (
          <Alert
            severity="info"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onCloseSold}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle className={styles.alertTitle}>
              Zoom = {meshDisplayableZoom} より過去事例表示は有効になります
            </AlertTitle>
            (現在 Zoom = {props.zoom})
          </Alert>
        ) : null}
        {openStickyNote &&
        props.stickyNote &&
        props.zoom < stickyNoteSearchableZoom ? (
          <Alert
            severity="info"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onCloseStickyNote}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle className={styles.alertTitle}>
              Zoom = {stickyNoteSearchableZoom} よりメモ表示は有効になります
            </AlertTitle>
            (現在 Zoom = {props.zoom})
          </Alert>
        ) : null}
        {openPricing && props.pricing ? (
          <Alert
            severity="info"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClosePricing}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <AlertTitle className={styles.alertTitle}>
              査定エリアを指定してください
            </AlertTitle>
          </Alert>
        ) : null}
      </Stack>
    );
  }
);
